import { getColors, Scheme } from '@osmosis/shared/styles';

type Options = {
  scheme?: Scheme;
};

export const getTheme = (options: Options = {}) => {
  const { scheme = 'light' } = options;

  return {
    breakpoints: ['40em', '52em', '64em'],
    fontSizes: [12, 14, 16, 20, 24, 32, 48, 64],
    colors: getColors(scheme),
    space: [0, 4, 8, 16, 32, 64, 128, 256],
    fontWeights: {
      body: 400,
      heading: 700,
      bold: 700,
    },
    lineHeights: {
      body: 1.5,
      heading: 1.25,
    },
    shadows: {
      small: 'rgb(6 26 54 / 6%) 0px 4px 12px',
      large: '0 0 24px rgba(0, 0, 0, .125)',
    },
    fonts: {},
    link: {},
    text: {},
    buttons: {},
    variants: {},
  };
};
